import React from 'react';
import { SERVICES } from './landingData';

const LandingMarquee = () => (
  <div style={{ borderTop:'1px solid var(--border-soft)', borderBottom:'1px solid var(--border-soft)', padding:'16px 0', overflow:'hidden', background:'var(--card-bg)' }}>
    <div style={{ display:'flex', animation:'marquee 30s linear infinite', whiteSpace:'nowrap', width:'max-content' }}>
      {[...SERVICES, ...SERVICES].map((s,i) => (
        <div key={i} style={{ fontFamily:'Bebas Neue,sans-serif', fontSize:19, letterSpacing:4, color:'var(--muted)', padding:'0 32px', display:'flex', alignItems:'center', gap:14 }}>
          <span style={{ width:5, height:5, background:'var(--accent)', borderRadius:'50%', flexShrink:0, display:'inline-block' }}/>{s.name}
        </div>
      ))}
    </div>
  </div>
);

export default LandingMarquee;
